import * as React from "react"

import { USER_ROLE, VISIBILITY_TRACKER_ROUTES } from "@constants"
import AppLayout from "Layout"
import ResourceMergePage from "./index"


export const VtResourceMergeRoutes = {
	path: VISIBILITY_TRACKER_ROUTES.RESOURCE_MERGE_PATH,
	title: VISIBILITY_TRACKER_ROUTES.RESOURCE_MERGE_TITLE,
	icon: 'merge',
	iconWeight: 'light',
	element: <AppLayout />,
	description: 'Visually deduplicate cross-day resource duplicates and merge them',
	access: USER_ROLE.ADMIN,
	children: [{
		element: <ResourceMergePage />,
		index: true,
	}],
}
